module.exports = __webpack_public_path__ + "img/Invasion-BRCA_SpatialResearch.4ef85150.png";